import { render, staticRenderFns } from "./Incident_3.vue?vue&type=template&id=0de1af58&scoped=true&"
import script from "./Incident_3.vue?vue&type=script&lang=js&"
export * from "./Incident_3.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/incident.css?vue&type=style&index=0&id=0de1af58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de1af58",
  null
  
)

export default component.exports